export default class Helper {
  static formatTime(
    ts,
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  ) {
    const d = new Date(Number(ts));
    return d
      .toLocaleString('sv-SE', { timeZone, hour12: false })
      .replace('T', ' ')
      .slice(0, 16)
      .replace(/-/g, '.');
  }

  static formatDate(
    ts,
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  ) {
    const d = new Date(Number(ts));
    return d.toLocaleDateString('sv-SE', { timeZone }).replace(/-/g, '.');
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Helper.js